import type { SessionResultDisplayRow } from '@multirx/shared/types/championship.js';
import { normalizeSessionResultOvertakes } from '@multirx/shared/game/driverPalmares.js';
import { labelOwnDriver } from '../auth/ownDriverLabel.js';
import { nationalityFlagMarkup } from '../components/nationalityFlag.js';
import { standingsRankCellHtml } from '../standings/standingsTableMarkup.js';
import {
  formatDiceRollsLabel,
  formatOvertakesCounteredLabel,
  formatOvertakesSucceededLabel,
} from '../play/raceResultsMarkup.js';

function escapeHtml(value: string): string {
  const div = document.createElement('div');
  div.textContent = value;
  return div.innerHTML;
}

/** @deprecated Préférer formatOvertakesSucceededLabel / formatOvertakesCounteredLabel. */
export function formatOvertakeDuelsLabel(count: number): string {
  return `${count} dépassement${count > 1 ? 's' : ''}`;
}

function statCell(count: number, title: string, modifierClass: string): string {
  return `<td class="play-race-results-cell play-race-results-cell--stat ${modifierClass}" title="${escapeHtml(title)}" aria-label="${escapeHtml(title)}">
    <span class="play-race-results-stat-count">${count}</span>
  </td>`;
}

export function buildChampionshipSessionResultsTableRows(
  rows: readonly SessionResultDisplayRow[]
): string {
  return rows
    .map((row) => {
      const flag = row.nationality
        ? nationalityFlagMarkup(row.nationality, { className: 'play-race-results-flag' })
        : '';
      const podiumClass =
        row.position === 1
          ? ' play-race-results-row--gold'
          : row.position === 2
            ? ' play-race-results-row--silver'
            : row.position === 3
              ? ' play-race-results-row--bronze'
              : '';
      const ot = normalizeSessionResultOvertakes(row);
      return `<tr class="play-race-results-row${podiumClass}">
        <td class="play-race-results-cell play-race-results-cell--rank">${standingsRankCellHtml(row.position)}</td>
        <td class="play-race-results-cell play-race-results-cell--driver">
          <span class="play-race-results-driver">
            ${flag}
            <span class="play-race-results-driver-text">
              <span class="play-race-results-driver-name">${escapeHtml(labelOwnDriver(row.driverName, row.driverId))}</span>
              ${
                row.carName
                  ? `<span class="play-race-results-car-name">${escapeHtml(row.carName)}</span>`
                  : ''
              }
            </span>
          </span>
        </td>
        ${statCell(row.diceRolls, formatDiceRollsLabel(row.diceRolls), 'play-race-results-stat--dice')}
        ${statCell(
          ot.overtakesSucceeded,
          formatOvertakesSucceededLabel(ot.overtakesSucceeded),
          'play-race-results-stat--overtake-ok'
        )}
        ${statCell(
          ot.overtakesCountered,
          formatOvertakesCounteredLabel(ot.overtakesCountered),
          'play-race-results-stat--overtake-block'
        )}
      </tr>`;
    })
    .join('');
}
